import { Routes, Route } from "react-router-dom";
import TerminalPlanning from "view/terminalPlanning/TerminalPlanning";

const index = () => {
	return (
		<Routes>
			<Route index element={<TerminalPlanning />} />
		</Routes>
	);
};

export default index;
